module.exports = __webpack_public_path__ + "assets/img/11_468.09f48105.jpg";